import angular from 'angular'

import namedInputComponent from './namedInput.component'

export default angular.module('app.common.forms.inputContainer.namedInput', [])
  .directive('input', namedInputComponent)
  .directive('textarea', namedInputComponent)
